module.exports = __webpack_public_path__ + "img/GoogleScannerIcon.025118cb.png";